import React, { useState, useEffect } from 'react';
import styles from '../../TransferPage.module.scss';
import success from 'assets/images/icn-success.svg';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { transcationActions } from '../../../../stores/_actions';

const Transfer = (props) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const saveRemittance = useSelector((state) => state.saveRemit);

  const [menu, setMenu] = useState({
    beneficiary: false,
    amount: false,
    payment: false,
    confirm: false,
    transfer: false,
    print: true,
  });

  const backButton = () => {
    history.goBack();
  };
  const [buttonActive, setButtonActive] = useState(false);

  useEffect(() => {
    if (saveRemittance.data != null) {
      setButtonActive(false);
    } else {
      setButtonActive(false);
    }
    dispatch(transcationActions.setLastVisitedPage('Transaction'));
  }, []);

  const forwordButton = () => {
    if (saveRemittance.data != null) {
      setButtonActive(false);
    } else {
      setButtonActive(true);
    }
    setMenu((menu) => (menu, (menu.print = true), (menu.transfer = false)));
    const menuValue = {
      ...location.state,
      menu,
      buttonActive,
    };
    history.push({ pathname: '/transfer', state: menuValue, msg: 'transaction completed' });
  };
  return (
    <>
      <div className={styles.successfull}>
        <img src={success} alt="" />
        {/* {saveRemittance.saveRemit == true ? <img src={success} alt="" /> : <div className={styles.spinner}></div>} */}
        {saveRemittance.saveRemit == true ? (
          saveRemittance.Message || `Your transaction has been completed. Please visit our nearest branch within 2 hours to complete the process.`
        ) : (
          <Link to="/transfer">Payment has been successfull.</Link>
        )}
      </div>
      <div className={styles.pageLeft__buttonCenter}>
        {/* <Button  onClick={backButton}>previous</Button> */}
        <Button className={buttonActive ? 'disabled' : ''} onClick={forwordButton}>
          {' '}
          next{' '}
        </Button>
      </div>
    </>
  );
};

export default Transfer;
